import { Device } from "@twilio/voice-sdk";
import { createContext } from "react";

export interface TwilioInterface {
  device: Device | null,
}

export const TwilioContext = createContext<TwilioInterface | null>(null);
